import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Check } from "@mui/icons-material";

import messages from "../../../../../../../assets/locale/messages";
import Button from "../../../../../../../components/Button";
import Modal from "../../../../../../../components/Modal";
import { approveOffPlatformDocs } from "../../../../../../../store/BusinessVerification/actions";
import { BlueBoxBgIcon } from "../../../../../../../utils/Icons";

const ApproveDocuments = () => {
  const dispatch = useDispatch();

  const lang = useSelector((state) => state.locale.lang);
  const {
    businessVerification: {
      actions: { approveDocs }
    },
    shared
  } = messages[lang];

  const requestDetails = useSelector(
    (state) => state.businessVerification.verificationRequestMainInfo
  );

  const [modalOpen, setModalOpen] = useState(false);

  const handleAcceptDocs = () => {
    dispatch(
      approveOffPlatformDocs({
        Id: requestDetails?.Id
      })
    );
    setModalOpen(false);
  };

  return (
    <div className="approve-documents">
      <Button
        label={
          <>
            <Check className="me-2" />
            {approveDocs.btnLabel}
          </>
        }
        success
        onClick={() => setModalOpen(true)}
      />
      {modalOpen && (
        <Modal
          open={modalOpen}
          icon={<BlueBoxBgIcon />}
          title={approveDocs.title.replace(
            ":companyName",
            requestDetails?.CompanyName || ""
          )}
          content={approveDocs.confirmMsg}
          confirmBtnTxt={shared.approve}
          cancelBtnTxt={shared.cancel}
          handleClose={() => setModalOpen(false)}
          handleCancel={() => setModalOpen(false)}
          handleConfirm={handleAcceptDocs}
        />
      )}
    </div>
  );
};

export default ApproveDocuments;
